import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'

const EmptyInternalRolesComponent = () => {
  return (
    <div css={tw`flex flex-1 flex-col items-center justify-center gap-2 p-10`}>
      <Typography variant="body1" css={tw`text-shades-700`}>
        No roles
      </Typography>
    </div>
  )
}

export const EmptyInternalRoles = memo(EmptyInternalRolesComponent)
